import { AxiosRequestConfig } from 'axios'
import { apiService } from '../../api-base'
import {
  CategoriesListResponse,
  CreateCategoryApiModel,
  NestedCategories,
  SingleCategoryApiResponse,
} from './types'

export class CategoriesService {
  static getCategories(
    config: AxiosRequestConfig,
  ): Promise<CategoriesListResponse> {
    return apiService.get<CategoriesListResponse>('/categories', config)
  }

  static updateCategories(data: {
    categories: NestedCategories[]
    storeId: string
  }): Promise<NestedCategories[]> {
    return apiService.post<NestedCategories[]>('/categories/update', data)
  }

  static createCategory(
    data: CreateCategoryApiModel,
  ): Promise<CreateCategoryApiModel[]> {
    return apiService.post<CreateCategoryApiModel[]>('/categories', data)
  }

  static getCategoryById(id: string): Promise<SingleCategoryApiResponse> {
    return apiService.get<SingleCategoryApiResponse>(`/categories/${id}`)
  }

  static updateCategory(
    id: string,
    data: CreateCategoryApiModel,
  ): Promise<CreateCategoryApiModel> {
    return apiService.put<CreateCategoryApiModel>(`/categories/${id}`, data)
  }

  static deleteCategory(id: string): Promise<{ success: boolean }> {
    return apiService.delete<{ success: boolean }>(`/categories/${id}`)
  }
}
